import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/composedReport/translations/TRANSLATION_KEYS'
import { useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import MeasureController from 'core/analytics/MeasureController'

import { OpenSavedFilterAreaModal } from './filterAreaModal/OpenSavedFilterAreaModal'
import { SaveFilterAreaModal } from './saveFilterAreaModal/SaveFilterAreaModal'

import styles from './FilterButtons.module.scss'

interface IProps {
  filter: () => void
  cleanFilter: () => void
  canClearFilter: boolean
  canApplyFilter: boolean
  metrics: MeasureController
}

export const FilterButtons = ({
  filter,
  cleanFilter,
  canClearFilter,
  canApplyFilter,
  metrics,
}: IProps) => {
  const [isOpenFilterModalDialog, setIsOpenFilterModalDialog] = useState<boolean>(false)
  const [isOpenSaveFilterModalDialog, setIsOpenSaveFilterModalDialog] = useState<boolean>(false)

  const onCloseOpenSavedFilterAreaModal = useCallback(() => {
    setIsOpenFilterModalDialog(false)
  }, [])

  const onOpenSavedFilterAreaModal = useCallback(() => {
    setIsOpenFilterModalDialog(true)
  }, [])

  const onCloseSaveFilterAreaModal = useCallback(() => {
    setIsOpenSaveFilterModalDialog(false)
  }, [])

  const onOpenSaveFilterAreaModal = useCallback(() => {
    setIsOpenSaveFilterModalDialog(true)
  }, [])

  return (
    <div className={styles.filtersBtns}>
      <Button disabled={!canApplyFilter} className={styles.filtersBtns_btn} onClick={filter}>
        <Translation text={TRANSLATION_KEYS.filter} />
      </Button>
      <Button className={styles.filtersBtns_btn} onClick={onOpenSavedFilterAreaModal}>
        <Translation text={TRANSLATION_KEYS.savedFiltersDialogOpen} />
      </Button>
      <Button className={styles.filtersBtns_btn} onClick={onOpenSaveFilterAreaModal}>
        <Translation text={TRANSLATION_KEYS.savedFiltersDialogSave} />
      </Button>
      <Button
        disabled={!canClearFilter}
        className={styles.filtersBtns_btn}
        onClick={cleanFilter}
        color={'danger'}
      >
        <Translation text={TRANSLATION_KEYS.clearFilter} />
      </Button>
      <OpenSavedFilterAreaModal
        isOpen={isOpenFilterModalDialog}
        onCloseDialog={onCloseOpenSavedFilterAreaModal}
        metrics={metrics}
      />
      <SaveFilterAreaModal
        isOpen={isOpenSaveFilterModalDialog}
        onCloseDialog={onCloseSaveFilterAreaModal}
      />
    </div>
  )
}
